import { render, staticRenderFns } from "./QuizModal.vue?vue&type=template&id=f4768e58&scoped=true&"
import script from "./QuizModal.vue?vue&type=script&lang=js&"
export * from "./QuizModal.vue?vue&type=script&lang=js&"
import style0 from "./QuizModal.vue?vue&type=style&index=0&id=f4768e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4768e58",
  null
  
)

export default component.exports